<template>
  <div class="py-2">
    <b-overlay :show="overlay.show">
      <b-tabs
        v-model="tabIndex"
        @input="emitChangeTabIndex()"
        content-class="mt-3"
        fill
        nav-class="small"
      >
        <b-tab :title="'Carrito ( ' + cart + ' )'" active>
          <div
            class="m-3 p-5 rounded text-center"
            style="background: #f1f1f1;"
            v-if="cart === 0"
          >
            No hay items en su carrito
          </div>
          <b-list-group
            flush
            class="mt-2 bg-light"
            v-if="cart !== 0 && viewType === 'List' && !loading"
          >
            <template v-for="(promos, promoid) in calcCartBooks.promos">
              <b-list-group-item
                :key="'promotitle-'+promoid"
                class="pt-0 pb-2 bg-light"
                style="line-height: 1rem; border-bottom: 1px solid rgba(0,0,0,.5); font-family: 'Poppins', sans-serif;"
              >
                <div class="text-muted small pt-2">PROMOCIÓN</div>
                <div
                  style="font-weight: 500;"
                >
                  {{promos.name}}
                </div>
              </b-list-group-item>
              <b-list-group :key="'promoList-'+promoid" flush class="pl-4 bg-light" style="border-bottom: 1px solid rgba(0,0,0,.5);">
                <b-list-group-item
                  style="font-size: small; padding: .5rem;"
                  v-for="item in promos.items"
                  class="bg-light"
                  :key="item.id + '-' + item.type"
                >
                  <div
                    style="font-weight: 500; margin-left: 25%; font-family: 'Poppins', sans-serif; line-height: 1rem;"
                  >
                    {{item.bookTitle}}
                  </div>
                  <div class="d-flex align-items-center">
                    <div style="position: relative; max-width: 25%; margin-top: -1.5rem; padding-right: .5rem;">
                    <b-img
                      :src="item.imgCover"
                      style="max-width: 100%"
                    />
                    <img
                      v-if="item.bookPrice[item.type].promo"
                      :src="$store.state.user.siteData.location +
                        'repository/promos/' + item.bookPrice[item.type].promo" 
                      style="
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        max-width: 100%"      
                      />
                    </div>
                    <div style="margin-top: .25rem;" v-if="item.type !== 4">
                      <div class="text-muted small" style="margin-bottom: .5rem;">
                        {{ getBookType(item.type) }}
                      </div>

                      <b-input-group size="sm" style="width: 5rem;">
                        <b-input-group-prepend>
                          <b-button @click="removeItem(item.id, item.type)"
                            >-</b-button
                          >
                        </b-input-group-prepend>

                        <b-form-input
                          class="text-center bg-secondary text-white"
                          style="padding:0px; border-color: #6c757d;"
                          disabled
                          :value="item.quantity"
                        ></b-form-input>

                        <b-input-group-append>
                          <b-button @click="addItem(item.id, item.type)"
                            >+</b-button
                          >
                        </b-input-group-append>
                      </b-input-group>

                      <div class="small mt-1">
                        <b-link @click="saveItem(item.id, item.type)"
                          >Guardar para después</b-link
                        >
                      </div>
                    </div>
                    <div class="small" style="margin-top: .25rem;" v-else-if="item.bookPrice[1].promotype && item.bookPrice[1].promotype === '4'">
                      <b-link @click="removeItem(item.id, item.type)"
                          >Quitar</b-link
                        >
                    </div>
                    <div style="margin-top: .25rem;" v-else-if="item.bookPrice[1].promotype && item.bookPrice[1].promotype === '5'">
                      <b-input-group size="sm" style="width: 5rem;">
                        <b-form-input
                            class="text-center bg-secondary text-white"
                            style="padding:0px; border-color: #6c757d;"
                            disabled
                            :value="item.quantity"
                          ></b-form-input>
                      </b-input-group>
                    </div>
                    <div
                      class="ml-auto"
                      style="font-weight: bold; font-size: 26px; margin-top: .5rem; font-family: 'Poppins', sans-serif;"
                    >
                      <span v-if="item.type !== 4">
                        $ {{ getBookCost(item.id, item.type) * item.quantity }}
                      </span>
                      <span v-else style="font-size: 16px;">
                        DE REGALO
                      </span>
                    </div>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </template>
            
            <b-list-group-item
              class="bg-light"
              style="font-size: small; padding: .5rem;"
              v-for="item in calcCartBooks.cart"
              :key="item.id + '-' + item.type"
            >
              <div
                style="font-weight: 500; margin-left: 25%; font-family: 'Poppins', sans-serif; line-height: 1rem;"
              >
                {{item.bookTitle}}
              </div>
              <div class="d-flex align-items-center">
                <div style="position: relative; max-width: 25%; margin-top: -1.5rem; padding-right: .5rem;">
                <b-img
                  :src="item.imgCover"
                  style="max-width: 100%"
                />
                <img
                  v-if="item.bookPrice[item.type].promo"
                  :src="$store.state.user.siteData.location +
                    'repository/promos/' + item.bookPrice[item.type].promo" 
                  style="
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    max-width: 100%"      
                  />
                </div>
                <div style="margin-top: .25rem;" v-if="item.type !== 4">
                  <div class="text-muted small" style="margin-bottom: .5rem;">
                    {{ getBookType(item.type) }}
                  </div>

                  <b-input-group size="sm" style="width: 5rem;">
                    <b-input-group-prepend>
                      <b-button @click="removeItem(item.id, item.type)"
                        >-</b-button
                      >
                    </b-input-group-prepend>

                    <b-form-input
                      class="text-center bg-secondary text-white"
                      style="padding:0px; border-color: #6c757d;"
                      disabled
                      :value="item.quantity"
                    ></b-form-input>

                    <b-input-group-append>
                      <b-button @click="addItem(item.id, item.type)"
                        >+</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>

                  <div class="small mt-1">
                    <b-link @click="saveItem(item.id, item.type)"
                      >Guardar para después</b-link
                    >
                  </div>
                </div>
                <div
                  class="ml-auto"
                  style="font-weight: bold; font-size: 26px; margin-top: .5rem; font-family: 'Poppins', sans-serif;"
                >
                  <span v-if="item.type !== 4">
                    $ {{ getBookCost(item.id, item.type) * item.quantity }}
                  </span>
                  <span v-else style="font-size: 16px;">
                    DE REGALO
                  </span>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
          <b-table
            :fields="[
              'productos',
              'cantidad',
              'precio_unitario',
              'descuento',
              'subtotal',
              { key: 'acciones', label: '' }
            ]"
            :items="cartItems"
            v-if="cart !== 0 && viewType === 'Table'"
          >
            <template v-slot:cell(productos)="data">
              <div class="d-flex align-items-center">
                <div style="position: relative; max-width: 15%;">
                <b-img
                  :src="getBookData(data.item.id, data.item.type, 1).imgCover"
                  style="max-width: 100%"
                />
                <img
                  v-if="getBookData(data.item.id, data.item.type, 1).bookPrice[data.item.type].promo"
                  :src="$store.state.user.siteData.location +
                    'repository/promos/' + getBookData(data.item.id, data.item.type, 1).bookPrice[data.item.type].promo" 
                  style="
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    max-width: 100%"      
                  />
                </div>
                <div style="text-align: left; margin-left:.5rem;">
                  <div style="font-weight: bold;">
                    {{getBookData(data.item.id, data.item.type, 1).bookTitle}}
                  </div>
                  <div class="text-muted small" v-if="data.item.type !== 4">
                    {{ getBookType(data.item.type) }}
                  </div>
                  <div class="small mt-2" v-if="data.item.type !== 4">
                    <b-link @click="saveItem(data.item.id, data.item.type)"
                      >Guardar para después</b-link
                    >
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:cell(cantidad)="data">
              <b-input-group size="sm" style="width: 5rem;" v-if="data.item.type !== 4">
                <b-input-group-prepend>
                  <b-button @click="removeItem(data.item.id, data.item.type)"
                    >-</b-button
                  >
                </b-input-group-prepend>

                <b-form-input
                  class="text-center bg-secondary text-white"
                  style="padding:0px; border-color: #6c757d;"
                  disabled
                  :value="data.item.quantity"
                ></b-form-input>

                <b-input-group-append>
                  <b-button @click="addItem(data.item.id, data.item.type)"
                    >+</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </template>
            <template v-slot:cell(precio_unitario)="data"
              >
              <span v-if="data.item.type !== 4">$ {{  getBookData(data.item.id, data.item.type, 1).bookPrice[data.item.type].regularprice }}</span></template
            >
            <template v-slot:cell(descuento)="data">
              <span v-if="data.item.type !== 4">{{ getBookDiscount(data.item.id, data.item.type) }}</span>
            </template>
            <template v-slot:cell(subtotal)="data"
              >
              <span v-if="data.item.type !== 4">
                $ {{ getBookCost(data.item.id, data.item.type) * data.item.quantity }}
              </span>
              <span v-else>
                REGALO
              </span>
            </template
            >
            <template v-slot:cell(acciones)="data">
              <div style="width:5rem;" v-if="data.item.type !== 4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="2rem"
                  viewBox="0 0 24 24"
                  width="2rem"
                  style="cursor:pointer;"
                  @click="removeCartAll(data.item.id, data.item.type)"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
                  />
                </svg>
              </div>
            </template>
          </b-table>
          <div class="d-flex m-2" v-if="cart !== 0 && viewType === 'Table'">
            <div
              class="rounded py-2 px-4 d-flex justify-content-between flex-fill subtotal-line"
              style="background: #f1f1f1;"
            >
              <div>Subtotal</div>
              <div>{{ cart }} items</div>
              <div>${{ calcSubtotal() }}</div>
            </div>
            <b-button
              size="sm"
              class="ml-3"
              style="background: #e8661a; border:none; line-height: 2rem; font-size: 1em;"
              @click="saveData()"
              >Siguiente</b-button
            >
          </div>
        </b-tab>
        <b-tab :title="'Guardado ( ' + saves + ' )'">
          <div
            class="m-3 p-5 rounded text-center"
            style="background: #f1f1f1;"
            v-if="saves === 0"
          >
            No hay items guardados
          </div>
          <b-list-group
            flush
            class="mt-2"
            v-if="saves !== 0 && viewType === 'List' && !loading"
          >
            <b-list-group-item
              style="font-size: small; padding: .5rem;"
              class="bg-light"
              v-for="item in saveItems"
              :key="item.id + '-' + item.type"
            >
              <div
                style="font-weight: 500; margin-left: 25%; font-family: 'Poppins', sans-serif; line-height: 1rem;"
              >
                {{getBookData(item.id, item.type, 2).bookTitle}}
              </div>
              <div class="d-flex align-items-center">
                <div style="position: relative; max-width: 25%; margin-top: -1.5rem; padding-right: .5rem;">
                <b-img
                  :src="getBookData(item.id, item.type, 2).imgCover"
                  style="max-width: 100%"
                />
                <img
                  v-if="getBookData(item.id, item.type, 2).bookPrice[item.type].promo"
                  :src="$store.state.user.siteData.location +
                    'repository/promos/' + getBookData(item.id, item.type, 2).bookPrice[item.type].promo" 
                  style="
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    max-width: 100%"      
                  />
                </div>
                <div style="margin-top: .25rem;">
                  <div class="text-muted small" style="margin-bottom: .5rem;">
                    {{ getBookType(item.type) }}
                  </div>

                  <b-input-group size="sm" style="width: 5rem;">
                    <b-input-group-prepend>
                      <b-button @click="removeSaveItem(item.id, item.type)"
                        >-</b-button
                      >
                    </b-input-group-prepend>

                    <b-form-input
                      class="text-center bg-secondary text-white"
                      style="padding:0px; border-color: #6c757d;"
                      disabled
                      :value="item.quantity"
                    ></b-form-input>

                    <b-input-group-append>
                      <b-button @click="addSaveItem(item.id, item.type)"
                        >+</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>

                  <div class="small mt-1">
                    <b-link @click="addFromSaves(item.id, item.type)"
                      >Pasar al carrito</b-link
                    >
                  </div>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
          <b-table
            :fields="[
              'productos',
              'cantidad',
              'precio_unitario',
              'subtotal',
              { key: 'acciones', label: '' }
            ]"
            :items="saveItems"
            v-if="saves !== 0 && viewType === 'Table'"
          >
            <template v-slot:cell(productos)="data">
              <div class="d-flex align-items-center">
                <div style="position: relative; max-width: 15%;">
                <b-img
                  :src="getBookData(data.item.id, data.item.type, 2).imgCover"
                  style="max-width: 100%"
                />
                <img
                  v-if="getBookData(data.item.id, data.item.type, 2).bookPrice[data.item.type].promo"
                  :src="$store.state.user.siteData.location +
                    'repository/promos/' + getBookData(data.item.id, data.item.type, 2).bookPrice[data.item.type].promo" 
                  style="
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    max-width: 100%"      
                  />
                </div>
                <div style="text-align: left; margin-letf: .5rem;">
                  <div style="font-weight: bold;">
                    {{getBookData(data.item.id, data.item.type, 2).bookTitle}}
                  </div>
                  <div class="text-muted small">
                    {{ getBookType(data.item.type) }}
                  </div>
                  <div class="small mt-2">
                    <b-link @click="addFromSaves(data.item.id, data.item.type)"
                      >Pasar al carrito</b-link
                    >
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:cell(cantidad)="data">
              <b-input-group size="sm" style="width: 5rem;">
                <b-input-group-prepend>
                  <b-button
                    @click="removeSaveItem(data.item.id, data.item.type)"
                    >-</b-button
                  >
                </b-input-group-prepend>

                <b-form-input
                  class="text-center bg-secondary text-white"
                  style="padding:0px; border-color: #6c757d;"
                  disabled
                  :value="data.item.quantity"
                ></b-form-input>

                <b-input-group-append>
                  <b-button @click="addSaveItem(data.item.id, data.item.type)"
                    >+</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </template>
            <template v-slot:cell(precio_unitario)="data"
              >$ {{ getBookCost(data.item.id, data.item.type, 1) }}</template
            >
            <template v-slot:cell(subtotal)="data"
              >$
              {{ getBookCost(data.item.id, data.item.type, 1) * data.item.quantity }}</template
            >
            <template v-slot:cell(acciones)="data">
              <div style="width:5rem;">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="2rem"
                  viewBox="0 0 24 24"
                  width="2rem"
                  style="cursor:pointer;"
                  @click="removeSaveAll(data.item.id, data.item.type)"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
                  />
                </svg>
              </div>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
      <template v-slot:overlay>
        <div class="text-center">
          ¿Cuantos items desea mover?
          <b-input
            type="range"
            v-model="overlay.inputvalue"
            :max="overlay.inputMax"
          />
          {{ overlay.inputvalue }}
          <br />
          <b-button
            size="sm"
            variant="outline-secondary"
            class="mr-2"
            @click="moveItem()"
            >Mover</b-button
          >
          <b-button
            variant="outline-danger"
            size="sm"
            aria-describedby="cancel-label"
            @click="overlay.show = false"
            >Cancelar</b-button
          >
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import axios from "axios";

export default {
  data: function() {
    return {
      tabIndex: 0,
      overlay: {
        show: false,
        inputvalue: 0,
        inputMax: 1,
        itemId: 0,
        itemType: 0,
        direction: 0
      },
      cartBooks: {},
      saveBooks: {},
      promos: [],
      loading: true,
      queueActions: []
    };
  },
  props: {
    viewType: String
  },
  computed: {
    calcCartBooks(){
      const calcCartBooks = {
        promos: {},
        cart: []
      }
      this.cartItems.forEach((element) => {
        let cartItem = Object.assign({},element)
        let searchID = element.id;
        if (element.type === 5) {
          searchID = 'c-' + element.id;
        }
        if (this.cartBooks[searchID]){
          cartItem = Object.assign(cartItem, this.cartBooks[searchID])
        } else {
          cartItem.imgCover = ''
          cartItem.bookTitle = 'Cargando...'
          cartItem.bookDesc = 'Cargando...'
          cartItem.bookId = element.id
          cartItem.bookPrice = {1: { price: 0, promo: null }}
          cartItem.bookWeight = {}
        }
        
        if (
            cartItem.bookPrice[element.type] !== undefined && 
            cartItem.bookPrice[element.type].promogroup !== null
          ) {
            if (calcCartBooks.promos[cartItem.bookPrice[element.type].promogroup] === undefined) {
              calcCartBooks.promos[cartItem.bookPrice[element.type].promogroup] = {
                name: cartItem.bookPrice[element.type].promoname,
                type: parseInt(cartItem.bookPrice[element.type].promotype),
                items: []
              }
              if (parseInt(cartItem.bookPrice[element.type].promotype) === 4 || parseInt(cartItem.bookPrice[element.type].promotype) === 5) {
                calcCartBooks.promos[cartItem.bookPrice[element.type].promogroup].promoInfo = {
                  base: parseInt(cartItem.bookPrice[element.type].promoquantity),
                  reward: parseInt(cartItem.bookPrice[element.type].promoreward)
                }
              }
            }
            calcCartBooks.promos[cartItem.bookPrice[element.type].promogroup].items.push(cartItem)
          } else if (element.type === 4){
            let promoname = null
            let promoid = null
            let promotype = null
            let promoInfo = null
            if (
              cartItem.bookPrice[1] !== undefined && 
              cartItem.bookPrice[1].promogroup !== null
            ) {
              promoname = cartItem.bookPrice[1].promoname
              promoid = cartItem.bookPrice[1].promogroup
              promotype = cartItem.bookPrice[1].promotype
              if (parseInt(cartItem.bookPrice[1].promotype) === 4 || parseInt(cartItem.bookPrice[1].promotype) === 5) {
                promoInfo = {
                  base: parseInt(cartItem.bookPrice[1].promoquantity),
                  reward: parseInt(cartItem.bookPrice[1].promoreward)
                }
              }
            } else {           
              this.promos.forEach((promoData) => {
                if (promoData.type === '2' && promoData.reward !== null) {
                  const rewards = promoData.reward.split(',');
                  rewards.forEach((reward) => {
                    if (parseInt(reward) === element.id) {
                      promoname = promoData.dgroupname
                      promoid = promoData.dgroup
                      promotype = 2
                    }
                  })
                }
              })
            }
            if (promoid !== null) {
              if (calcCartBooks.promos[promoid] === undefined) {
                calcCartBooks.promos[promoid] = {
                  name: promoname,
                  type: promotype,
                  items: []
                }
              }
              if (promoInfo !== null) {
                calcCartBooks.promos[promoid].promoInfo = promoInfo;
              }
              calcCartBooks.promos[promoid].items.push(cartItem)
            } else {
              calcCartBooks.cart.push(cartItem)
            }
          } else {
            calcCartBooks.cart.push(cartItem)
          }
      })
      console.log('Lista actualizada');
      // Recalcular lista
      this.calcList(calcCartBooks);
      return calcCartBooks
    },
    ...mapState({
      cartItems: state => state.cart.cartItems,
      saveItems: state => state.saves.saveItems,
      cartLoading: state => state.cart.pendingLoad
    }),
    ...mapGetters({ cart: "countCartItems", saves: "countSaveItems" })
  },
  watch:{
    cartItems:{
      handler(){
        if (!this.cartLoading) {
          this.updateCartBooks();
          // this.calcPromos();
        }
      },
      deep: true
    },
    saveItems(){
      if (!this.cartLoading) {
        this.updateSaveBooks();
      }
    },
    cartBooks(){
      this.calcPromos();
    }
  },
  mounted(){
    this.updateCartBooks();
    this.updateSaveBooks();
    this.getGeneralPromo();
  },
  methods: {
    async updateCartBooks(){
      console.log(this.$store.state.user.siteData);

      this.cartBooks = await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getForList",
          JSON.stringify({items: this.cartItems}),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = {};
          
          evtResponse.data.records.forEach(element => {
            let img = ''
            if (element.price[5] === undefined) {
              img = this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img
            } else {
              img = this.$store.state.user.siteData.location +
                "repository/combos/" +
                element.id
            }
            let index = parseInt(element.id);
            if (element.price[5] !== undefined) {
              index = 'c-' + index;
            }
            result[index] = ({
              imgCover: img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookPrice: element.price,
              bookWeight: element.weight      
            });
            this.loading = false;
          });          
          return result;
        });
    },
    async updateSaveBooks(){
      console.log(this.$store.state.user.siteData);

      this.saveBooks = await axios
        .post(
          this.$store.state.user.siteData.location + "items/books/getForList",
          JSON.stringify({items: this.saveItems}),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          const result = {};
          evtResponse.data.records.forEach(element => {
            let img = ''
            if (element.price[5] === undefined) {
              img = this.$store.state.user.siteData.location +
                "repository/books/" +
                element.id +
                "_" +
                element.img
            } else {
              img = this.$store.state.user.siteData.location +
                "repository/combos/" +
                element.id
            }
            let index = parseInt(element.id);
            if (element.price[5] !== undefined) {
              index = 'c-' + index;
            }
            result[index] = ({
              imgCover: img,
              bookTitle: element.title,
              bookDesc: element.author,
              bookId: parseInt(element.id),
              bookPrice: element.price,             
            });
          });
          this.loading = false;
          return result;
        });
    },
    async getGeneralPromo(){
      await axios
        .post(
          this.$store.state.user.siteData.location + "discounts/discounts/getForAll",
          null,
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          this.promos = evtResponse.data.records;
          this.calcPromos();
        });
    },
    emitChangeTabIndex: function() {
      this.$emit("changeTabIndex", this.tabIndex);
    },
    getBookType: function(itemType) {
      switch (parseInt(itemType)) {
        case 1:
          return "Tapa blanda";
        case 2:
          return "Tapa dura";
        case 3:
          return "E-book";
        case 4:
          return "Regalo";
        case 5:
          return "Combo";
      }
    },
    getBookCost: function(itemId, itemType, list = 0) {
      let searchID = itemId;
      if (itemType === 5) {
        searchID = 'c-' + itemId;
      }    
      if (list === 0){
        if (this.cartBooks[searchID] === undefined) {
          return 0
        }
        return parseInt(this.cartBooks[searchID].bookPrice[itemType].price)
      }else{
        if (this.saveBooks[searchID] === undefined) {
          return 0
        }
        return parseInt(this.saveBooks[searchID].bookPrice[itemType].price)
      }
    },
    getBookDiscount: function(itemId, itemType) {      
      let searchID = itemId;
      if (itemType === 5) {
        searchID = 'c-' + itemId;
      }
      if (this.cartBooks[searchID] === undefined) {
        return ' - ';
      }
      const price = parseInt(this.cartBooks[searchID].bookPrice[itemType].price)
      const regularprice = parseInt(this.cartBooks[searchID].bookPrice[itemType].regularprice)
      if (price === regularprice){
        return ' - ';
      }else{
        return '$ '+ (regularprice - price);
      }      
    },
    getBookData: function(itemId, itemType, list) {
      let searchID = itemId;
      if (itemType === 5) {
        searchID = 'c-' + itemId;
      }
      if (list === 1) {
        return this.cartBooks[searchID];
      } else {
        return this.saveBooks[searchID];
      }
    },
    calcSubtotal: function() {
      let result = 0;
      this.cartItems.forEach(
        function(element) {
          result += this.getBookCost(element.id, element.type) * element.quantity;
        }.bind(this)
      );

      return result;
    },
    addItem: function(itemId, itemType) {
      this.addCartItem({ id: itemId, type: itemType });
    },
    removeItem: function(itemId, itemType) {
      this.removeCartItem({ id: itemId, type: itemType });
    },
    addSaveItem: function(itemId, itemType) {
      this.addSaveItem({ id: itemId, type: itemType });
    },
    removeSaveItem: function(itemId, itemType) {
      this.removeSaveItem({ id: itemId, type: itemType });
    },
    saveItem: function(itemId, itemType) {
      const itemQuantity = this.$store.getters.getItemByType({
        id: itemId,
        type: itemType
      });
      if (itemQuantity < 2) {
        this.removeCartItem({ id: itemId, type: itemType });
        this.addSaveItem({ id: itemId, type: itemType });
        this.tabIndex = 1;
      } else {
        this.overlay.inputvalue = itemQuantity;
        this.overlay.inputMax = itemQuantity;
        this.overlay.itemId = itemId;
        this.overlay.itemType = itemType;
        this.overlay.direction = 1;
        this.overlay.show = true;
      }
    },
    addFromSaves: function(itemId, itemType) {
      const itemQuantity = this.$store.getters.getSaveItemByType({
        id: itemId,
        type: itemType
      });
      if (itemQuantity < 2) {
        this.removeSaveItem({ id: itemId, type: itemType });
        this.addCartItem({ id: itemId, type: itemType });
        this.tabIndex = 0;
      } else {
        this.overlay.inputvalue = itemQuantity;
        this.overlay.inputMax = itemQuantity;
        this.overlay.itemId = itemId;
        this.overlay.itemType = itemType;
        this.overlay.direction = 2;
        this.overlay.show = true;
      }
    },
    moveItem: function() {
      this.overlay.inputvalue = parseInt(this.overlay.inputvalue);
      if (this.overlay.direction === 1) {
        this.removeCartItem({
          id: this.overlay.itemId,
          type: this.overlay.itemType,
          quantity: this.overlay.inputvalue
        });
        this.addSaveItem({
          id: this.overlay.itemId,
          type: this.overlay.itemType,
          quantity: this.overlay.inputvalue
        });
        this.tabIndex = 1;
      } else {
        this.removeSaveItem({
          id: this.overlay.itemId,
          type: this.overlay.itemType,
          quantity: this.overlay.inputvalue
        });
        this.addCartItem({
          id: this.overlay.itemId,
          type: this.overlay.itemType,
          quantity: this.overlay.inputvalue
        });
        this.tabIndex = 0;
      }
      this.overlay.show = false;
    },
    removeCartAll: function(itemId, itemType) {
      const itemQuantity = this.$store.getters.getItemByType({
        id: itemId,
        type: itemType
      });
      let showMessage = "";
      if (itemQuantity === 1) {
        showMessage = "¿Está seguro que quiere quitar este objeto del carrito?";
      } else {
        showMessage =
          "¿Está seguro que quiere quitar estos " +
          itemQuantity +
          " objetos del carrito?";
      }
      this.$bvModal
        .msgBoxConfirm(showMessage, {
          title: "Quitar del carrito",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "SÍ",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.removeCartItem({
              id: itemId,
              type: itemType,
              quantity: itemQuantity
            });
          }
        });
    },
    removeSaveAll: function(itemId, itemType) {
      const itemQuantity = this.$store.getters.getSaveItemByType({
        id: itemId,
        type: itemType
      });
      let showMessage = "";
      if (itemQuantity === 1) {
        showMessage = "¿Está seguro que quiere quitar este objeto guardado?";
      } else {
        showMessage =
          "¿Está seguro que quiere quitar estos " +
          itemQuantity +
          " objetos guardados?";
      }
      this.$bvModal
        .msgBoxConfirm(showMessage, {
          title: "Quitar de guardados",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "SÍ",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.removeSaveItem({
              id: itemId,
              type: itemType,
              quantity: itemQuantity
            });
          }
        });
    },
    saveData(){
      let cartWeight = 0;
      let cartDiscounts = 0;
      const cartTotal = this.calcSubtotal();

      this.cartItems.forEach(
        function(element) {
          let searchID = element.id;
          if (element.type === 5) {
            searchID = 'c-' + element.id;
          }
          cartWeight += parseInt(this.cartBooks[searchID].bookWeight[element.type]) * element.quantity;
          cartDiscounts += parseInt(this.cartBooks[searchID].bookPrice[element.type].regularprice) * element.quantity;
        }.bind(this)
      );

      this.$emit('change', {step1: { precio: cartTotal, peso: cartWeight, discounts: cartDiscounts - cartTotal} });
      this.$router.push('/cart/step2');
    },
    calcList(calcCartBooks){
      if (this.queueActions.length === 0){
        if (Object.keys(calcCartBooks.promos).length > 0) {
          for(const cartPromo in calcCartBooks.promos) {
            console.log('Analizar: ', calcCartBooks.promos[cartPromo]);

            if (parseInt(calcCartBooks.promos[cartPromo].type) === 4) {
              const rewadBooks = [];
              let countBooks = 0;
              calcCartBooks.promos[cartPromo].items.forEach((calcPromoBook) => {
                if (calcPromoBook.type === 4) {
                  rewadBooks.push(calcPromoBook)
                }
                countBooks += calcPromoBook.quantity;
              })
              
              if (calcCartBooks.promos[cartPromo].promoInfo && countBooks >= calcCartBooks.promos[cartPromo].promoInfo.base) {
                const sortbooks = calcCartBooks.promos[cartPromo].items.slice(0)
                sortbooks.sort(function (a, b) {
                  const firstBookPrice = parseInt(a.bookPrice[1].price)
                  const secondBookPrice = parseInt(b.bookPrice[1].price)
                  return firstBookPrice - secondBookPrice
                })
                console.log('Libros ordenados: ', sortbooks);
                console.log('Libros regalo: ', rewadBooks);
                
                for(let i=0; i < calcCartBooks.promos[cartPromo].promoInfo.reward; i++) {
                  let yaesta = false;
                  rewadBooks.forEach((rewardToSearch) => {
                    if (
                      rewardToSearch.id === sortbooks[i].id ||
                      rewardToSearch.bookPrice[1].price === sortbooks[i].bookPrice[1].price
                      ) {
                      yaesta = true;
                    }
                  });
                  console.log('yaesta: ', yaesta);
                  if (!yaesta) {
                    this.removeCartItem({ id: parseInt(sortbooks[i].id), type: sortbooks[i].type});
                    this.addCartItem({ id: parseInt(sortbooks[i].id), type: 4 });
                  }
                }
                if (rewadBooks.length > calcCartBooks.promos[cartPromo].promoInfo.reward) {
                  rewadBooks.sort(function (a, b) {
                    const firstBookPrice = parseInt(a.bookPrice[1].price)
                    const secondBookPrice = parseInt(b.bookPrice[1].price)
                    return firstBookPrice - secondBookPrice
                  })
                  for(let i= calcCartBooks.promos[cartPromo].promoInfo.reward; i < rewadBooks.length; i++) {
                    this.removeCartItem({ id: parseInt(rewadBooks[i].id), type: 4});
                    this.addCartItem({ id: parseInt(rewadBooks[i].id), type: 1 });
                  }
                }                
              }
              
              if (
                countBooks - rewadBooks.length === 0 ||
                (calcCartBooks.promos[cartPromo].promoInfo && countBooks < calcCartBooks.promos[cartPromo].promoInfo.base)
                ){
                rewadBooks.forEach((deleteBook) => {
                  this.removeCartItem({ id: parseInt(deleteBook.id), type: 4});
                  this.addCartItem({ id: parseInt(deleteBook.id), type: 1 });
                })
              }
            } else if (parseInt(calcCartBooks.promos[cartPromo].type) === 5 && calcCartBooks.promos[cartPromo].promoInfo) {
              const base = calcCartBooks.promos[cartPromo].promoInfo.base;
              const rewardCount = calcCartBooks.promos[cartPromo].promoInfo.reward
              const bookCount = {}
              calcCartBooks.promos[cartPromo].items.forEach((element) => {
                if (bookCount[element.id] === undefined) {
                  bookCount[element.id] = { items: 0, rewards: 0};
                }
                if (element.type !== 4) {
                  bookCount[element.id].items = element.quantity;
                } else {
                  bookCount[element.id].rewards = element.quantity;
                }
              });
              for(const bookCheck in bookCount){
                  const booksDif = Math.floor((bookCount[bookCheck].items + bookCount[bookCheck].rewards) / base) - bookCount[bookCheck].rewards * rewardCount;
                  console.log('Calculo: ', Math.floor((bookCount[bookCheck].items + bookCount[bookCheck].rewards) / base), bookCount[bookCheck].rewards * rewardCount );
                  console.log('Diff:', booksDif);
                  
                  if (booksDif > 0 ){
                    console.log('Agregar ' + booksDif + ' del libro ' + bookCheck);
                    this.removeCartItem({ id: parseInt(bookCheck), type: 1 });
                    this.addCartItem({ id: parseInt(bookCheck), type: 4});
                  } else if (booksDif < 0 || bookCount[bookCheck].items === 0) {
                    console.log('Remover ' + (booksDif * -1) + ' del libro ' + bookCheck);
                    this.removeCartItem({ id: parseInt(bookCheck), type: 4 });
                    this.addCartItem({ id: parseInt(bookCheck), type: 1 });
                  }
                  
              }
              console.log(bookCount);
            }
          }
          if (this.queueActions.length > 0) {
            this.calcPromos()
          }
        }
      }
    },
    calcPromos() {
      if (this.cartLoading) {
        return false;
      }
      if (this.queueActions.length > 0) {
        const id = this.queueActions[0].id;
        const type = this.queueActions[0].type;
        const action = this.queueActions[0].action;
        let quantity = 1;
        if (this.queueActions[0].quantity) {
          quantity = this.queueActions[0].quantity;
        }
        this.queueActions.splice(0,1);

        if (action === 'add') {          
          this.addCartItem({ id: parseInt(id), type: type, quantity: quantity });
        } else {
          this.removeCartItem({ id: parseInt(id), type: type, quantity: quantity });
        }
        console.log('Action: ', action, 'ID: ', id, 'Type: ', type, 'Quantity: ' , quantity);
        console.log('Actualizó cola');
        return true;
      }
      let promoCartItems = 0;
      let promoItems = [];
      this.cartItems.forEach((cartItem) => {
        if (cartItem.type === 4 && this.cartBooks[cartItem.id].bookPrice[1].promotype !== '4' && this.cartBooks[cartItem.id].bookPrice[1].promotype !== '5') {
          promoCartItems ++;
          promoItems.push(cartItem.id);
        }
      });

      /* Si el carrito está vacío saca los libros en promo */
      if (this.cartItems.length - promoCartItems <= 0 && promoItems.length > 0) {
        this.removeCartItem({ id: parseInt(promoItems[0]), type: 4 });
        console.log('Borra el ' + promoItems[0]);
        return true;
      }

      /* Si la promo no esta más saco los libros regalo */
      if (promoCartItems > 0) {
        this.promos.forEach((promoData) => {
          if (promoData.type === '2' && promoData.reward !== null) {
            const rewards = promoData.reward.split(',');
            rewards.forEach((reward, rewardkey) => {
              rewards[rewardkey] = parseInt(reward)
            })
            promoItems = promoItems.filter((value) => {
              return !rewards.includes(value)
            })
          }
        })
        if (promoItems.length > 0) {
          for(let p = 0; p < promoItems.length; p++) {
            if  (this.cartBooks[promoItems[p]].bookPrice[1].promotype === '4' || this.cartBooks[promoItems[p]].bookPrice[1].promotype === '5') {
              promoItems.splice(p,1);
              p --;
            }
          }
        }
        console.log('Items no en promo: ', promoItems)
        if (promoItems.length > 0) {
          this.removeCartItem({ id: parseInt(promoItems[0]), type: 4 });
          console.log('Borra el ' + promoItems[0]);
          return true;
        }
      }

      if (this.promos.length > 0 && this.cartItems.length > 0) {
        const itemstoadd = [];
        const itemstoremove = [];
        this.promos.forEach((element) => {
          if (element.type === '2' && element.reward !== null) {
            const rewards = element.reward.split(',');
            let readyToAdd = true
            if (element.promobooks !== '0') {
              readyToAdd = false
              if (this.calcCartBooks.promos[element.dgroup] !== undefined && this.calcCartBooks.promos[element.dgroup].items.length > 0){
                let notPromoBooks = 0
                let firstPromoBook = null
                this.calcCartBooks.promos[element.dgroup].items.forEach((notpromobook) => {
                  if (notpromobook.type !== 4) {
                    notPromoBooks ++;
                  } else if (firstPromoBook === null) {
                    firstPromoBook = notpromobook.id
                  }
                })
                if (notPromoBooks > 0) {
                  readyToAdd = true
                } else {
                  itemstoremove.push(firstPromoBook)
                }
              }
            }
            if (readyToAdd) {              
              rewards.forEach((reward) => {
                let esta = false;
                this.cartItems.forEach((cartItem) => {
                  if (cartItem.id === parseInt(reward)) {
                    /*
                    if (cartItem.type !== 4 && !itemstoremove.includes(reward)) {
                      itemstoremove.push(reward)
                    }
                    */
                    if (cartItem.type === 4) {
                      esta = true;
                    }
                  }
                })
                if (!esta && !itemstoadd.includes(reward)) {
                  itemstoadd.push(reward);
                }
              })
            }
          }
        })

       if (itemstoremove.length > 0) {
        this.removeCartItem({ id: parseInt(itemstoremove[0]), type: 4 });
        console.log('Borra el ' + itemstoremove[0]);
        return true;
       }

       if (itemstoadd.length > 0) {
        this.addCartItem({ id: parseInt(itemstoadd[0]), type: 4 });
       }

        console.log(itemstoadd, itemstoremove, this.cartLoading);
      }
    },
    ...mapActions([
      "addCartItem",
      "removeCartItem",
      "addSaveItem",
      "removeSaveItem"
    ])
  }
};
</script>
